import client from '../client'

/**
 * Get invoice by location Id
 * @param {object} query See below
 * @param {string} query.brandId brandId to query
 */
export const getInvoice = ({ brandId }) =>
  client.get('/billing/invoices', { brandId })

/**
 * Get Invoice by id
 * @param {object} query see below
 * @param {string} query.brandId brandId for query
 * @param {string} query.invoiceId invoiceId to query
 */
export const getInvoiceById = ({ brandId, invoiceId }) =>
  client.get(`/billing/invoices/${invoiceId}`, { brandId })

/**
 *
 *Get Subscriptions
 * @param {string} brandId Create subscription data
 */
export const getSubscriptions = ({ brandId }) =>
  client.get('/billing/subscriptions', { brandId })

/**
 *
 *Create subscription
 * @param {object} subscriptionData Create subscription data
 */
export const createSubscription = (subscriptionData) =>
  client.post('/billing/subscriptions', subscriptionData)

/*
 *
 * Update Subscription
 *
 * @param {string} brandId Create subscription data
 */
export const updateSubscription = ({ locationId, paymentMethodId }) =>
  client.patch(
    `/locations/${locationId}/billing/subscriptions/payment-method`,
    {
      paymentMethodId,
    }
  )

/**
 *
 *Get Payment Method(s)
 * @param {object} query See below
 * @param {string} query.brandId Brand Ids
 */
export const getPaymentMethods = async ({ brandId }) =>
  client.get(`/brands/${brandId}/billing/payment-methods`)

/**
 *
 *Create Payment Method On Olympus
 * @param {object} query See below
 * @param {string} query.brandId Brand Ids
 * @param {string} query.paymentMethodId Payment Method Id
 */
export const createPaymentMethod = async ({ brandId, paymentMethodId }) =>
  client.post(`/brands/${brandId}/billing/payment-method`, { paymentMethodId })

/**
 *
 *Retry Payment
 * @param {object} query See below
 * @param {string} query.invoiceId Invoice Id
 * @param {string} query.locationId Location Id
 */
export const retryInvoicePayment = async ({ invoiceId, locationId }) =>
  client.post(`/locations/${locationId}/invoices/${invoiceId}/retry-payment`)
